import React, { Component } from "react";
import css from "./UnitInput.module.css";

class UnitInput extends Component {
  state = {
    value: this.props.value
  };
  componentWillReceiveProps(newProps) {
    this.setState({ value: newProps.value });
  }
  handleTextValueChange = e => {
    let textValue = e.target.value;
    if (isNaN(textValue)) {
      textValue = textValue
        .substring(0, textValue.length - this.props.suffix.length)
        .trim();
      if (isNaN(textValue)) return;
    } else {
      e.target.setSelectionRange(0, 10);
    }
    if (textValue === "") textValue = "0";

    textValue = this.validate(textValue);

    textValue = textValue.toString();
    e.target.value = `${textValue}${this.props.suffix}`;
    e.target.setSelectionRange(textValue.length, textValue.length);

    if (isNaN(textValue)) return;
    this.setState({ value: textValue });
    this.props.onValueChange(textValue);
    e.preventDefault();
  };
  handleValueChange = e => {
    this.props.onValueChange(e.target.value);
  };
  handlePressureToggle = e => {
    this.props.onPressureToggle(!this.props.pressureToggle);
  };
  validate = v => {
    let value = parseInt(v, 10);
    value = Math.min(value, this.props.max);
    value = Math.max(value, this.props.min);
    return value;
  };
  submit = e => {
    this.focus(e);
    // this.props.onValueChange(this.state.value);
  };
  focus = e => {
    e.target.setSelectionRange(0, e.target.value.length);
  };

  render() {
    return (
      <React.Fragment>
        <input
          className={css.unitInput}
          size="3"
          type="text"
          value={`${this.state.value}${
            this.props.suffix ? this.props.suffix : ""
          }`}
          onChange={this.handleTextValueChange}
          onFocus={this.focus}
          onBlur={this.submit}
          onKeyDown={e => {
            if (e.keyCode === 13) {
              // e.target.blur();
              this.submit(e);
            }
          }}
        />
      </React.Fragment>
    );
  }
}

export default UnitInput;
